declare var require;

export const environment = {
  production: true,
  stripePublishableKey:
    "pk_live_51MqgruCiltV3mNpPt8ILjhQlBnU4jdc1IgWDXnLUGPc8DrsU83xOHwdrtsGsK2sEFiVJass8EyJeE3t65jrcjrTm00iIKfLywD",
  version: require("../../package.json").version,
  apiEndpoint: "https://api.chatgptkeeper.com",
};
